import axios from "axios";
import Swal from "sweetalert2";

if (typeof window !== "undefined") {
    window.Swal = Swal;
}

export const id = (id) => document.getElementById(id)
export const idValue = (id) => id(id).value
export const idInnerHTML = (id) => id(id).innerHTML
export const warningSign = "\u26A0"; // danger warning sign

/**
 * Decodes HTML entities (e.g. &#039;, &#39;, &quot;, &amp;, &lt;, &gt;)
 * and unrolls double-encoded entity prefixes (&amp;#039; -> &#039; -> ').
 * @param {*} value
 * @returns {string}
 */
export const decodeHtml = (value) => {
    if (value === null || value === undefined) return '';
    let decoded = String(value).replace(/&amp;(#\d+|#x[0-9a-f]+|[a-z]+);/gi, '&$1;');
    return decoded
        .replace(/&(?:#0*39|#x0*27|apos);/gi, "'")
        .replace(/&(?:#0*34|#x0*22|quot);/gi, '"')
        .replace(/&(?:#0*60|#x0*3c|lt);/gi, '<')
        .replace(/&(?:#0*62|#x0*3e|gt);/gi, '>')
        .replace(/&(?:#0*38|#x0*26|amp);/gi, '&');
};

/**
 * Escape a value for safe interpolation into an HTML template string.
 * Use this on every user-controlled field (names, bios, occupations, free text)
 * that ends up in an `.innerHTML = ` assignment \u2014 SEC-2.
 * Decodes existing entities first so pre-encoded strings never double-encode.
 * @param {*} value
 * @returns {string}
 */
export const esc = (value) => {
    if (value === null || value === undefined) return '';
    const clean = decodeHtml(value);
    return clean
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

/**
 * Current CSRF token. Prefers the `XSRF-TOKEN` cookie (kept in sync with the
 * session by app/config/init.php on every request) over the <meta> tag, which
 * is frozen at page render and goes stale after a session-token regeneration
 * (e.g. straight after 2FA).
 * @returns {string}
 */
export const getCsrfToken = () => {
    const fromCookie = (document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/) || [])[1];
    if (fromCookie) return decodeURIComponent(fromCookie);
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
};

export const qSel = (name) => document.querySelector(name)
export const qSelAll = (name) => document.querySelectorAll(name)
export const qSelValue = (name) => qSel(name).value
export const qSelInnerHTML = (name) => qSel(name).innerHTML

export const log = (id, identifier =null) => {
    console.log(' start'+ "  " + identifier)
    console.log(id)
    console.log(' end'+ "  " +identifier)
}
export const write = (input) => document.write(input)

export const hideElement = (elementId) => {
  id(elementId).style.display = "none";
};

export const showElement = (elementId) => {
  id(elementId).style.display = "block";
};

export const manipulateAttribute = (idName, removeOrSet, attributeType, nameValue =null) => {

    if(removeOrSet === "remove") {
           id(idName).removeAttribute(attributeType)
    } else {
        id(idName).setAttribute(attributeType, nameValue)
    }
 
  
}

export const date2String = (date) => new Date().toDateString(date)

export const showError = (e) => {
    log(e.message, " ERROR MESSAGE") // "null has no properties"
    if (e.name) log(e.name, " ERROR NAME") // "TypeError"
    if (e.fileName) log(e.fileName,  " ERROR FILENAME") // "Scratchpad/1"
    if (e.lineNumber) log(e.lineNumber, " ERROR LINENUMBER") // 2
    if (e.stack) log(e.stack)

    // Extract message if it's an Axios error
    let userMessage = "An unexpected error occurred.";
    if (e.response && e.response.data && e.response.data.message) {
        userMessage = e.response.data.message;
    } else if (e.message) {
        userMessage = e.message;
    }

    // Try to show it in an error div if it exists, otherwise alert
    const errEl = id('error');
    if (errEl) {
        errEl.innerHTML = userMessage;
        errEl.style.display = 'block';
        errEl.style.color = 'red';
    } else {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: userMessage,
            timer: 3000,
            showConfirmButton: false
        });
    }
}

export const msgException = (errorMessage) => {
  
    throw new Error(errorMessage)
}


/**
 * 
 * @param {*} elementId - element id
 * @param {*} addClass either a success or danger class (green or red)
 * @param {*} message - html message to convey success or failure
 * @param {*} timer - timer for the message to disappear- default is 5 secs
 */
export const showNotification = (elementId, addClass, message, timer = 5000) => {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: timer,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
    });

    let iconType = 'info';
    if (addClass.includes('success')) iconType = 'success';
    if (addClass.includes('danger') || addClass.includes('error')) iconType = 'error';
    if (addClass.includes('warning')) iconType = 'warning';

    Toast.fire({
        icon: iconType,
        title: message
    });

    const loader = id('loader');
    if (loader) loader.classList.remove('loader');
}

    // Function to check for elements and render if they exist
    export const checkElements = (idOrClass, classString, theFunction = null) => {

        const doesElementExist = (idOrClass === "id") ? id(classString) : qSel(classString)
        // Check if elements exist before calling render function
        if (doesElementExist.length) {
            theFunction(doesElementExist);
        }

    };

     export const checkManyElements = (idOrClass, classString, theFunction = null) => {

        const doesElementExist = (idOrClass === "id") ? id(classString) : qSelAll(classString)
        // Check if elements exist before calling render function
        if (doesElementExist.length > 0) {
            theFunction(doesElementExist);
        }

    };

    const yourId = localStorage.getItem('requesterId');
    const famCode = localStorage.getItem('requesterFamCode');

    // delete notification 
    export const deleteNotification = async (elementId) => {

         // Extract the user ID from the target ID
            const senderId = elementId.replace("deleteNotification", "notificationBar");
          
            const elementData = id(elementId)
            const data = elementData.getAttribute("data-id");

            // change the background of the clicked element 

            const notificationHTML = id(senderId);

            // Make sure required variables are defined before using them
            if (
                typeof yourId === 'undefined' ||
                typeof famCode === 'undefined'
            ) {
                msgException("Required parameters (yourId or famCode) are not defined");
            }

            const url = `/removeNotification/${yourId}/${famCode}/${data}`


            const response = await axios.put(url)


            if (response.data.message === "Notification marked as read") {

                // remove a html element with notificationBar after 2 mins 
                notificationHTML.remove()

                // reduce the notification count as you have deleted the notification

                const newValues = parseInt(sessionStorage.getItem('notificationCount') - 1)
                id('notification_count').innerHTML = newValues;
            } else {
                msgException("Error removing notification" + " " + response.data.message);
            }
    }

/**
 * Defensive Error Unwrapping Utility
 *
 * Guarantees that [object Object] is NEVER returned under any error shape.
 * Handles strings, standard Error objects, Axios responses, validation maps.
 *
 * @param {any} err
 * @param {string} defaultMessage
 * @returns {string}
 */
export const extractErrorMessage = (err, defaultMessage = 'An unexpected error occurred.') => {
    if (err === null || err === undefined) {
        return defaultMessage;
    }

    if (typeof err === 'string') {
        const trimmed = err.trim();
        return trimmed && trimmed !== '[object Object]' ? trimmed : defaultMessage;
    }

    if (err && typeof err === 'object') {
        const resData = err.response ? err.response.data : (err.data || null);

        if (resData) {
            if (typeof resData === 'string') {
                const trimmed = resData.trim();
                if (trimmed && trimmed !== '[object Object]') return trimmed;
            } else if (typeof resData === 'object') {
                if (typeof resData.error === 'string' && resData.error.trim() && resData.error.trim() !== '[object Object]') {
                    return resData.error.trim();
                }
                if (typeof resData.message === 'string' && resData.message.trim() && resData.message.trim() !== '[object Object]') {
                    return resData.message.trim();
                }
                if (typeof resData.msg === 'string' && resData.msg.trim() && resData.msg.trim() !== '[object Object]') {
                    return resData.msg.trim();
                }

                const errorsSource = resData.errors || resData.error;
                if (errorsSource && typeof errorsSource === 'object') {
                    if (Array.isArray(errorsSource)) {
                        const msgs = errorsSource.map(m => typeof m === 'string' ? m : (m?.message || JSON.stringify(m))).filter(Boolean);
                        if (msgs.length > 0) return msgs.join(', ');
                    } else {
                        const values = Object.values(errorsSource).flat().map(v => typeof v === 'string' ? v : (v?.message || JSON.stringify(v))).filter(Boolean);
                        if (values.length > 0) return values.join(', ');
                    }
                }
            }
        }

        if (typeof err.message === 'string' && err.message.trim() && err.message.trim() !== '[object Object]') {
            return err.message.trim();
        }

        if (typeof err.error === 'string' && err.error.trim() && err.error.trim() !== '[object Object]') {
            return err.error.trim();
        }
        if (typeof err.msg === 'string' && err.msg.trim() && err.msg.trim() !== '[object Object]') {
            return err.msg.trim();
        }

        if (err.errors && typeof err.errors === 'object') {
            if (Array.isArray(err.errors)) {
                const msgs = err.errors.map(m => typeof m === 'string' ? m : (m?.message || JSON.stringify(m))).filter(Boolean);
                if (msgs.length > 0) return msgs.join(', ');
            } else {
                const values = Object.values(err.errors).flat().map(v => typeof v === 'string' ? v : (v?.message || JSON.stringify(v))).filter(Boolean);
                if (values.length > 0) return values.join(', ');
            }
        }

        try {
            if (typeof err.toString === 'function') {
                const str = err.toString();
                if (str && str !== '[object Object]' && typeof str === 'string') {
                    return str;
                }
            }
        } catch (_) {}

        try {
            const jsonStr = JSON.stringify(err);
            if (jsonStr && jsonStr !== '{}' && jsonStr.length < 200) {
                return jsonStr;
            }
        } catch (_) {}
    }

    return defaultMessage;
};

if (typeof window !== 'undefined') {
    window.extractErrorMessage = extractErrorMessage;
}